import styled from "styled-components";

const Tabela = styled.div`
  .header-right {
    background-color: #041E42 !important;
    color: white !important;
  }
  .header-right .p-column-header-content {
    justify-content: flex-end !important;
    padding-right: 16px;
  }
  /* linha selecionada */
  .p-datatable .p-datatable-tbody > tr.p-highlight {
    background-color: #ff9800 !important;
    color: #041e42 !important;
    font-weight: bold !important;
    transition: background-color 0.3s ease !important;
  }

  /* Estilo dos botões da paginação */
  .minha-tabela-faturas .p-paginator button,
  .minha-tabela-faturas .p-paginator .p-paginator-page,
  .minha-tabela-faturas .p-paginator .p-paginator-prev,
  .minha-tabela-faturas .p-paginator .p-paginator-next,
  .minha-tabela-faturas .p-paginator .p-paginator-first,
  .minha-tabela-faturas .p-paginator .p-paginator-last {
    background-color: #041e42;
    color: white;
    border-radius: 4px;
    border: 1px solid #041e42;
    margin: 0 2px;
    transition: all 0.3s ease;
  }

  .minha-tabela-faturas .p-paginator button:hover,
  .minha-tabela-faturas .p-paginator .p-paginator-page:hover,
  .minha-tabela-faturas .p-paginator .p-paginator-prev:hover,
  .minha-tabela-faturas .p-paginator .p-paginator-next:hover,
  .minha-tabela-faturas .p-paginator .p-paginator-first:hover,
  .minha-tabela-faturas .p-paginator .p-paginator-last:hover {
    background-color: white;
    color: #041e42;
    border: 1px solid #041e42;
  }

  .minha-tabela-faturas .p-paginator .p-paginator-page.p-highlight {
    background-color: #ff9800;
    color: #041e42;
    border: 1px solid #ff9800;
  }

  .minha-tabela-faturas .p-paginator .p-paginator-current {
    color: #041e42;
  }

  /* Layout */
  display: flex;
  flex-direction: column;
  height: 820px;
  width: 100%;
  padding-top: 15px;
  margin-bottom: 50px;

  /* 👇 remove o cursor piscando e o foco fantasma */
  * {
    outline: none !important;
    caret-color: transparent !important;
  }

  /* previne foco visual dentro da tabela */
  .p-datatable:focus,
  .p-datatable-tbody:focus,
  .p-datatable-tbody > tr:focus,
  .p-datatable-tbody > tr > td:focus {
    outline: none !important;
    box-shadow: none !important;
  }
`;

export default Tabela;
